import React from 'react';
import aboutContent from '../Data/aboutContent.json';

const CustomTimeline = () => {
  const milestones = aboutContent.milestones;

  return (
    <section className="bg-world-img bg-no-repeat bg-contain w-full text-gray-800">
      <div className="container max-w-5xl px-4 py-12 mx-auto">
        <div className="grid gap-4 mx-4 sm:grid-cols-12">
          <div className="col-span-12 sm:col-span-3">
            <div className="text-center sm:text-left mb-14 before:block before:w-24 before:h-3 before:mb-5 before:rounded-md before:mx-auto sm:before:mx-0 before:bg-csyellow">
              <h3 className="text-3xl font-semibold">Our Journey</h3>
              <span className="text-sm font-bold tracking-wider uppercase text-gray-600">Milestones</span>
            </div>
          </div>
          <div className="relative col-span-12 px-4 space-y-6 sm:col-span-9">
            <div className="col-span-12 space-y-12 relative px-4 sm:col-span-8 sm:space-y-8 sm:before:absolute sm:before:top-2 sm:before:bottom-0 sm:before:w-0.5 sm:before:-left-3 before:bg-gray-300">
              {milestones.map((event, index) => (
                <div key={index} className="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:bg-csyellow">
                  <h3 className="text-xl font-semibold tracking-wide">{event.title}</h3>
                  <time className="text-s tracking-wide uppercase font-semibold text-gray-600">{event.date}</time>
                  <p className="mt-3 font-thin text-lg">{event.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomTimeline;